module.exports = __webpack_public_path__ + "media/empty-states/sessions-77ffbce9.png";